



















































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { ReportModule } from "@/store/modules/report.store";
import { PartnerEntity } from "@/models/partnerEntity";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";

@Component({
  components: { LayoutReport }
})
export default class ThgPrivacy extends Vue {
  get partner(): PartnerEntity {
    return ReportModule?.partner;
  }

  get isDatasharingActive(): boolean {
    return !!this.partner?.settings?.isDatasharingActive;
  }

  get isWhiteLabelPartner(): boolean {
    return this.partner.partnerType !== PartnerTypeEnum.THG_WHITE_LABEL_MINT_FUTURE;
  }

  get url(): string {
    let url = "https://www.wirkaufendeinethg.de";
    if (this.isWhiteLabelPartner) {
      if (this.partner?.settings?.urls && this.partner?.settings?.urls.length) {
        url = "https://" + this.partner.settings.urls[0];
      }
    }
    return url;
  }

  get companyName(): string {
    return this.partner?.companyName;
  }

  get street(): string {
    return this.partner?.address?.street || "";
  }

  get city(): string {
    return this.partner?.address?.city || "";
  }

  get zip(): string {
    return this.partner?.address?.zip || "";
  }
}
